import { Injectable } from "@angular/core";
import { IndustryDiscount } from "src/app/ui/models/domains/pbm/industry/industry-discount.model";
import { AbstractParser } from "../../parser";
import { parseIndustryDiscount } from "./industry-discount-functions";

@Injectable()
export class IndustryDiscountParser extends AbstractParser<IndustryDiscount> {
  parse(payload: any): IndustryDiscount {
    return parseIndustryDiscount(payload);
  }
}
